<template>
  <div card-image :style="video ? '' : `background-image: url('${selectImg}')`" :class="{shadow}">
    <video v-if="video" :src="video"  muted autoplay loop playsinline/>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CardImage',
  props: {
    img: { default: null },
    video: { default: null },
    shadow: { type: Boolean, default: false},
  },
  computed: {
    selectImg() {
      return this.sect === 'sm' && this.img.sm ? this.img.sm
          : this.img.lg ? this.img.lg
          : this.img;
    }
  }
};
</script>

<style lang="less">
@import "~@/less/proj";
[card-image] { .bgc(#ccc); .cover; .bg-c; .no-repeat; .rel; overflow: hidden;
  video { .abs; .lt(50%,50%); .min-h(101%); .min-w(101%); transform: translate(-50%,-50%);}
  &.shadow:before { .cnt; .abs; .lt; .block; .wh(100%,100%); background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000); opacity: 0.64; }
}
</style>
